import axios from 'axios';

const API_URL = process.env.REACT_APP_SERVER_URL + '/server-health';

function authHeader() {
    const token = localStorage.getItem('gpcwstoken_kw');
    return { Authorization: `Bearer ${token}` };
}

export interface ServerHealth {
    success: boolean;
    ok: boolean;
    timestamp: string;
    uptimeSeconds: number;
    nodeVersion: string;
    platform: string;
    memory: { rssMb: number; totalMb: number; freeMb: number };
    database: { ok: boolean; latencyMs: number; error?: string };
}

export interface SqlAccountWarehouse {
    warehouseId: number;
    label: string;
}

export interface SqlAccountTestResult {
    success: boolean;
    warehouseId: number;
    label: string;
    ok: boolean;
    latencyMs: number;
    error?: string;
}

const ServerHealthService = {
    getHealth: async (): Promise<ServerHealth> => {
        const response = await axios.get(`${API_URL}/`, { headers: authHeader() });
        return response.data;
    },

    getSqlAccountWarehouses: async (): Promise<{ success: boolean; warehouses: SqlAccountWarehouse[] }> => {
        const response = await axios.get(`${API_URL}/sql-account/warehouses`, { headers: authHeader() });
        return response.data;
    },

    testSqlAccount: async (warehouseId: number): Promise<SqlAccountTestResult> => {
        const response = await axios.post(`${API_URL}/sql-account/${warehouseId}/test`, {}, { headers: authHeader() });
        return response.data;
    },
};

export default ServerHealthService;
